import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Claim, ProviderType } from '@cms-max/medicare-api-sdk'
import { getUserData } from 'redux/reducers/users'
import { useSelector } from 'react-redux'
import { CLAIMS_URLS_ENGLISH, CLAIMS_URLS_SPANISH } from '../urls'
import { useMedicareUrl } from 'hooks/useMedicareUrl'
import { base64Encode } from 'utils/base64-helper'
import { MyLink } from 'components/MyLink'

export interface ClaimQualityLinksProps {
  claim:Claim|undefined
}

export const ClaimQualityLinks: FC<ClaimQualityLinksProps> = ({ claim }) => {
  const { t } = useTranslation('claimsSearch', { keyPrefix: 'claimDetails' })
  const userData = useSelector(getUserData)
  const providerData = {
    action: 'MyMedicareLinkToQualityRatings',
    data: {
      providerType: claim?.providerDetails?.providerType,
      providerId: claim?.providerDetails?.providerId,
      zipcode: userData?.user?.mailingAddress?.zip
    }
  }
  const qualityLinkURL = useMedicareUrl(
    CLAIMS_URLS_ENGLISH.ccxpQualityLink,
    CLAIMS_URLS_SPANISH.ccxpQualityLink
  )
  const encodedProviderData = base64Encode(JSON.stringify(providerData))
  const linkURL = qualityLinkURL + '?relay=' + encodedProviderData

  return (
    <>
      <div className='m-c-card ds-u-padding--3 ds-u-margin-top--2'>
        <div className='ds-l-row'>
          <div className='ds-l-col'>
            {claim?.providerDetails?.providerType === ProviderType.Hos && (
              <>
                <MyLink href={linkURL}>
                  {t('qualityLinks.hospitalLinkText')}
                </MyLink>
                <p className='ds-u-margin-top--2'>{t('qualityLinks.hospitalDescText')}</p>
              </>
            )}
            {claim?.providerDetails?.providerType === ProviderType.Nhc && (
              <>
                <MyLink href={linkURL}>
                  {t('qualityLinks.nursingHomeLinkText')}
                </MyLink>
                <p className='ds-u-margin-top--2'>{t('qualityLinks.nursingHomeDescText')}</p>
              </>
            )}
            {claim?.providerDetails?.providerType === ProviderType.Hhc && (
              <>
                <MyLink href={linkURL}>
                  {t('qualityLinks.homeHealthLinkText')}
                </MyLink>
                <p className='ds-u-margin-top--2'>{t('qualityLinks.homeHealthDescText')}</p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
